<template>
  <div class="main">
    <div class="tablediv">
      <div class="total-title">
        <span class="top-title">我的订单</span>
      </div>
      <div class="orderList">
        <div v-if="totalCnt == 0" class="el-table__empty-block">
          <span class="el-table__empty-text">暂无订单</span>
        </div>
        <div class="ordercard" v-for="(item,index) in tableData" :key="index" :class="[item.status == 9?'opacity':'']">
          <el-row class="ordercard-row1">
            <el-col :span="18">
              <span class="order-span1">订单号 {{item.bid}}</span>
              <span v-if="item.status == 0" class="orange order-span2">待支付<span class="orange order-span3">请在下单后30分钟内完成支付</span></span>
              <span v-if="item.status == 1" class="gray order-span2">已完成</span>
              <span v-if="item.status == 9" class="gray order-span2">已取消</span>
            </el-col>
            <el-col :span="6" class="txt-right">
              <span class="order-span4">下单日期：{{item.createtime}}</span>
            </el-col>
          </el-row>
          <el-row class="ordercard-row2">
            <el-col :span="18">
              <span class="order-span4 order-span5">{{item.gtypename}}</span>
              <span class="order-span4 order-span5">对应印宝：{{item.bcontent.length}}台</span>
              <span class="order-span4 order-span5">使用期限：
                  {{item.bcontent[0].gmodel=="按年" ?(item.bcontent[0].amount/12).toFixed(0): item.bcontent[0].amount}}
                  {{item.bcontent[0].gmodel=="按年" ? "年" : "月"}}
              </span>
              <span class="order-span4 order-span5">金额：{{item.bamount}}元</span>
            </el-col>
            <el-col :span="6" class="txt-right">
              <el-button v-if="item.status == 0" size="mini" class="gotopaybtn" style="padding:7px 0;" @click="payOrder(item)">{{item.tsch}}支付</el-button>
              <el-button v-if="item.status == 0"  size="mini" class="cancelpaybtn" @click="cancelOrder(item)">取消订单</el-button>
              <el-button v-if="item.status == 1" size="mini" class="showDetailbtn" @click="showOrder(item)">查看订单</el-button>
            </el-col>
          </el-row>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageindex"
          :page-size="pagesize"
          layout="total,  prev, pager, next, jumper"
          :total="totalCnt"
        ></el-pagination>
      </div>
    </div>
    <section v-show="orderDetailDialogShow">
      <orderDetailDialog
        transition="fade"
        transition-mode="out-in"
        v-bind:info="info"
        :visible="orderDetailDialogShow"
        @close="onOrderClose"
      ></orderDetailDialog>
    </section>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="300px" :before-close="handleClose">
      <div class="paydialog-content">
        <div class="QRcode" v-qr="qrcode"  v-if="dialogVisible"></div>
        <div style="text-align: center;margin-top: 16px;">
          <label class="pay-lb3">{{dialogTitle}}</label>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../components/util";
import orderDetailDialog from "./orderDetailDialog";
export default util.useCommon({
  data() {
    return {
      pagesize: 10,
      pageindex: 1,
      totalCnt: 0,
      tableData: [],
      orderDetailDialogShow: false,
      info:"",
      dialogVisible: false,
      qrcode: {
        text: '',
        render: "canvas",
        width: 260,
        height: 260,
        typeNumber: -1,
        correctLevel: 2,
        background: "#ffffff",
        foreground: "#000000"
      },
      dialogTitle :""
    };
  },
  components: {
    orderDetailDialog: orderDetailDialog
  },
  computed: {},
  methods: {
    payOrder(item){
      var v = this;
      if(item.tsch == '支付宝'){
          v.dopost("/order/alipay",
            {
              rechargeid: item.bid,
              price: item.bamount
            },
            function(paydata) {
              if ("0000" === paydata.state) {
                v.qrcode.text = paydata.body.qrCode;
                v.dialogVisible = true;
                v.dialogTitle = "使用支付宝扫码付款";
                var interval = window.setInterval(function() {
                  v.dopost("/order/getPayStatus",{bid:item.bid,tsch:"ali"},function(statusdata) {
                    if ("0000" === statusdata.state) {
                      if(statusdata.body=="1"){
                        v.dialogVisible = false;
                        window.clearInterval(interval);
                        v.message("success", "支付成功！");
                        v.query();
                      }
                    }
                  });                      
                }, 30000);//30秒刷一次
              } else {
                var msg = [];
                for (var i = 0; i < paydata.body.length; i++) {
                  msg.push(paydata.body[i].errmsg);
                }
                v.message("error", msg.join("<br/>"));
              }
              console.log(paydata);
            });
      }else{
        // 微信支付
        v.dopost("/order/wxpay",
            {
              rechargeid: item.bid,
              price: item.amount
            },
            function(paydata) {
              if ("0000" === paydata.state) {
                v.qrcode.text=paydata.body.qrCode;
                v.dialogVisible = true;
                v.dialogTitle = "使用微信扫码付款";
                var interval = window.setInterval(function() {
                  v.dopost("/order/getPayStatus",{bid:item.bid,tsch:"wx"},function(statusdata) {
                    if ("0000" === statusdata.state) {
                      if(statusdata.body=="1"){
                        v.dialogVisible = false;
                        window.clearInterval(interval);
                        v.message("success", "支付成功！");
                        v.query();
                      }
                    }
                  });                      
                }, 30000);//30秒刷一次
              } else {
                var msg = [];
                for (var i = 0; i < paydata.body.length; i++) {
                  msg.push(paydata.body[i].errmsg);
                }
                v.message("error", msg.join("<br/>"));
              }
              console.log(paydata);
            });
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
    },
    onOrderClose(result) {
      this.orderDetailDialogShow = false;
    },
    showOrder(item) {
      var v = this;
      v.info = item;
      // console.log(item);
      v.orderDetailDialogShow = true;
    },
    cancelOrder(item){
      var v = this;
      v.confirm("确定取消?", function(isOk) {
        if (isOk) {
          v.dopost(
            "/order/cancelOrder",
            {
              bid :item.bid,
              tsch: item.tsch
            },
            function(result) {
              if ("0000" === result.state) {
                v.message("success", "订单取消成功！");
                v.query();
              } else {
                var msg = [];
                for (var i = 0; i < result.body.length; i++) {
                  msg.push(result.body[i].errmsg);
                }
                v.message("error", msg.join("<br/>"));
              }
              console.log(result);
            }
          );
        }
      });
    },
    showOrderDetail(item){
      var v = this;
      this.$router.push({name:"orderDetail",params:jsonPara({info:item})});
    },
    queryList() {
      //查询订单列表
      var v = this;
      v.dopost(
        "/order/getOrderList",
        {
          pagesize: v.pagesize,
          pageindex: v.pageindex,
          owner :v.owner
        },
        function(result) {
          if ("0000" === result.state) {
            v.tableData = result.body.list;
            v.totalCnt = result.body.totalCnt;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
    query() {
      var v = this;
      v.pageindex = 1;
      v.queryList();
    },
    handleCurrentChange(val) {
      var v = this;
      v.pageindex = val;
      v.queryList();
    },
  },
  created: function() {},
  activated() {
    var v = this;
    if (!v.nyy.userInfo) {
      v.$router.replace("/");
    }else{
      v.owner = v.nyy.userInfo.owner;
      v.corp = v.nyy.userInfo.corp;
      v.query();
    }
  },
  mounted() {}
});
</script>
<style scoped>
.QRcode{
  width: 260px;
  height: 260px;
  margin: 10px auto;
  margin-bottom: 0px;
}
.main {
  overflow: auto;
}
.orderList {
  padding: 29px 32px 0px 31px;
}
.ordercard {
  width: 100%;
  border: #d9dde3 2px solid;
  border-radius: 10px;
  margin-bottom: 20px;
}
.ordercard-row1 {
  border-bottom: 1px #e3e6eb dashed;
  padding: 17px 21px 9px 16px;
}
.ordercard-row2 {
  padding: 13px 17px 8px 19px;
}
.order-span1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.order-span2 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding-left: 15px;
}
.order-span3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding-left: 15px;
  position: relative;
  top: -3px;
}
.order-span4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8295ae;
}
.order-span5 {
  margin-right: 34px;
}
.gray{
  color: #8295AE;
}
.opacity{
  opacity: 0.3;
}
</style>